// ======================================================================
// File Name       : CourseEditUserContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form, FormControl, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as courseActions from '../../actions/CourseAction';
import * as ModalAction from '../../actions/ModalAction';
import CustomButton from '../../components/button/CustomButton';
import CourseEditUser from '../../components/course/CourseEditUser';
import CourseEditUserSearchList from '../../components/course/CourseEditUserSearchList';
import SelectGroupDlg from '../../components/course/SelectGroupDialog';
import MessageSearch from '../../components/MessageSearch';
import ModalWrapper from '../../components/modal/ModalWrapper';
import SelectBox from '../../components/SelectBox';
import { RETURN_MAX_NUM, RETURN_MAX_NUM_1000 } from '../../constants';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { REDIRECT_MODAL } from '../../constants/CourseConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import { USER_TYPE } from '../../constants/UserConstants';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';

class CourseEditUserContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectGroup: false,
      isAllowShowSearchMessage: false,
      isInit: true,
    };
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.handlesearchUserConditionChange = this.handlesearchUserConditionChange.bind(this);
    this.handleUserTypeChange = this.handleUserTypeChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.clickSearchBtn = this.clickSearchBtn.bind(this);
    this.handleUserCheck = this.handleUserCheck.bind(this);
    this.handleAddRemoveAllUser = this.handleAddRemoveAllUser.bind(this);
    this.handleRemoveAllUserRelation = this.handleRemoveAllUserRelation.bind(this);
    this.handleAddUserRelation = this.handleAddUserRelation.bind(this);
    this.handlePeriodTimeChange = this.handlePeriodTimeChange.bind(this);
    this.handleRemoveUserRelation = this.handleRemoveUserRelation.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.validation = this.validation.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
  }

  componentDidMount() {
    const { dispatch, userInfo } = this.props;
    if (userInfo && userInfo.userSecernId) {
      const userSecernId = userInfo.userSecernId;
      dispatch(courseActions.getUserCourseRelation(userSecernId));
    }
    this.handleSearchBtn();
  }

  handleBackBtn() {
    const { dispatch, modalId, course } = this.props;
    const { editingCourse } = course;
    const { dataAffiliationType } = editingCourse;
    if (dataAffiliationType && dataAffiliationType === DATA_AFFIILIATION_TYPE.EXTERNAL) {
      this.props.hideModal();
    } else {
      dispatch(ModalAction.openModal(REDIRECT_MODAL[modalId].CANCEL));
    }
  }

  handleNextBtn() {
    const { dispatch, modalId, course } = this.props;
    const imageFileSelectType = course.editingCourse.imageFileSelectType;
    if (this.validation()) {
      dispatch(ModalAction.openModal(REDIRECT_MODAL[modalId].OK));
    }
  }

  handlesearchUserConditionChange(event) {
    const { dispatch } = this.props;
    const { name, value } = event.target;
    dispatch(courseActions.editingUserSearchCondition({ [name]: value }));
  }

  handleUserTypeChange(event) {
    const { dispatch, authority } = this.props;
    const { managementAuthorityList } = authority;
    const { name, value } = event.target;

    // Reset managementAuthoritySecernId when switch usertype
    const managementAuthoritySecernId = '';
    dispatch(courseActions.editingUserSearchCondition(
      { [name]: value, managementAuthoritySecernId }));
  }

  clickSearchBtn() {
    this.setState({ isInit: false }, () => {
      this.handleSearchBtn();
    });
  }

  handleSearchBtn() {
    const { dispatch, course } = this.props;
    const { checkedUser, editingUser } = course;
    if (checkedUser && editingUser) {
      checkedUser.allSecernIds = checkedUser.allSecernIds.reduce((acc, cur, index) => {
        if (checkedUser.bySecernId[cur] && !editingUser[cur]) {
          delete checkedUser.bySecernId[cur];
        } else {
          acc.push(cur);
        }
        return acc;
      }, []);
    }
    this.setState(
      {
        isAllowShowSearchMessage: false,
      },
      () => {
        dispatch(
          courseActions.searchUser({
            ...course.searchUserCondition,
            startPosition: 0,
            returnMaxNum: RETURN_MAX_NUM,
          }),
        ).then(() => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
        });
      },
    );
  }

  handlePageChange(startPosition) {
    const { dispatch, course } = this.props;
    dispatch(
      courseActions.searchUser({
        ...course.searchUserCondition,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM,
      }),
    );
  }

  handleAddRemoveAllUser() {
    const { dispatch } = this.props;
    dispatch(courseActions.addRemoveAllUser());
  }

  handleUserCheck(event) {
    const userSecernId = event.target.value;
    const { dispatch } = this.props;
    dispatch(courseActions.addRemoveUser(userSecernId));
  }

  handleAddUserRelation() {
    const { dispatch } = this.props;
    this.scrollToBottom();
    dispatch(courseActions.addUserRelation());
  }

  handlePeriodTimeChange(userSecernId, name, mDate) {
    const { dispatch } = this.props;
    // #7230 START
    const mDateTxt = mDate && mDate.format ? mDate.format(mDate.format) : mDate;
    // #7230 END
    dispatch(courseActions.editPeriodTime(userSecernId, { [name]: mDateTxt }));
  }

  handleRemoveUserRelation(userSecernId) {
    const { dispatch, course, isAdminHasCourseRelation } = this.props;
    const { editingUser } = course;
    let userType = null;
    if (editingUser && editingUser[userSecernId] && editingUser[userSecernId].userType) {
      userType = parseInt(editingUser[userSecernId].userType, 10);
    }
    if (
      !isAdminHasCourseRelation ||
      (isAdminHasCourseRelation && userType !== USER_TYPE.ADMIN)
    ) {
      dispatch(courseActions.removeUserRelation(userSecernId));
    }
  }

  handleRemoveAllUserRelation() {
    const { isAdminHasCourseRelation } = this.props;
    this.props.dispatch(courseActions.removeAllUserRelation(isAdminHasCourseRelation));
  }

  getModalOptions() {
    return {
      title: 'コースに紐付けるユーザーを選択してください',
      footerBtns: null,
      dialogClassName: 'course-edit-user-dialog',
    };
  }

  /**
   * Remove selected group
   */
  removeSelectedGroup() {
    const { dispatch } = this.props;
    dispatch(courseActions.editingUserSearchCondition({ selectedGroup: {} }));
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    this.setState({ showSelectGroup: true });
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    this.setState({ showSelectGroup: false });
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   * @param {object} group
   */
  okSelectGroupDlg(group) {
    const { dispatch } = this.props;
    this.setState(
      {
        showSelectGroup: false,
      },
      () => {
        dispatch(courseActions.editingUserSearchCondition({ selectedGroup: group }));
      },
    );
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }
  scrollToBottom() {
    const node = document.getElementById('scroll-table-course');
    node.scrollIntoView({ behavior: 'smooth' });
  }
  render() {
    this.refsToValidate = [];
    const { authority, course, groupList, isAdminHasCourseRelation } = this.props;
    const {
      searchUserCondition,
      searchUserResult,
      courseRelations,
      editingUser,
      checkedUser,
      editingCourse,
    } = course;
    const { recordNumUserCourseRelation } = editingCourse;
    const { selectedGroup } = searchUserCondition;
    const groupNameString = selectedGroup
      ? convertNodeGroupToNodeString(selectedGroup.groupSecernId, groupList)
      : '';
    const recordNumCourseRelations = courseRelations ? courseRelations.recordNum : 0;
    const isShowMessageMaxRecord = recordNumCourseRelations > RETURN_MAX_NUM_1000;

    // let managementAuthorityList } = authority;
    let managementAuthorityList = [];
    const managementAuthorityListFirst = [
      {
        managementAuthoritySecernId: '',
        managementAuthorityName: '',
      },
    ];
    if (authority && authority.managementAuthorityList) {
      managementAuthorityList = managementAuthorityListFirst.concat(authority.managementAuthorityList);
    }
    return (
      <ModalWrapper
        temporaryHide={this.state.showSelectGroup ? 'hidden' : ''}
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <div>
          <div className="max-width-950">
            <MessageSearch
              recordNum={searchUserResult ? searchUserResult.recordNum : 0}
              resultList={searchUserResult ? searchUserResult.allSecernIds : []}
              isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
              dismissMessage={this.dismissMessage}
            />
            { !isShowMessageMaxRecord &&
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.clickSearchBtn();
                }}
                className='form-horizontal margin-bottom-15'
              >
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    ユーザー名
                  </Col>
                  <Col sm={9} className='padding-right-15'>
                    <FormControl
                      name="userName"
                      value={searchUserCondition.userName || ''}
                      onChange={this.handlesearchUserConditionChange}
                    />
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    ログインID
                  </Col>
                  <Col sm={9} className='padding-right-15'>
                    <FormControl
                      name="loginId"
                      value={searchUserCondition.loginId || ''}
                      onChange={this.handlesearchUserConditionChange}
                    />
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    グループ名
                  </Col>
                  <Col sm={9}>
                    <Button variant="primary" className="btn-96" onClick={this.showSelectGroupDlg}>
                      グループ選択
                    </Button>
                  </Col>
                </Form.Group>
                {groupNameString && (
                    <Form.Group className="form-info" controlId="formHorizontalGroup">
                      <Col sm={3}>
                      </Col>
                      <Col sm={7} as={Form.Label} className='padding-left-clear'>
                        {groupNameString}
                      </Col>
                      <Col sm={2}>
                        <Button variant="primary" className="btn-96" onClick={this.removeSelectedGroup.bind(this)}>
                          削除
                        </Button>
                      </Col>
                    </Form.Group>
                  )}
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    自由記述領域
                  </Col>
                  <Col sm={2}>
                    <SelectBox
                      name="userAttributeKeyNum"
                      data={USER_ATTRIBUTE_KEY_NUM_LIST}
                      value={searchUserCondition.userAttributeKeyNum}
                      onChange={this.handlesearchUserConditionChange}
                    />
                  </Col>
                  <Col sm={7} className='padding-left-15 padding-right-15'>
                    <FormControl
                      name="userAttributeSearchText"
                      value={searchUserCondition.userAttributeSearchText || ''}
                      onChange={this.handlesearchUserConditionChange}
                    />
                  </Col>
                </Form.Group>
                <Row>
                  <Col sm={12} className="text-center padding-top-10">
                    {/* <Button bsStyle="primary" className="btn-96" type="submit">
                      search
                    </Button> */}
                    <CustomButton
                      btnStyle="btn btn-primary btn-96"
                      type="submit"
                      text="検索"
                      iconClass="bi bi-search"
                    />
                  </Col>
                </Row>
              </Form>
            }
          </div>
          { !isShowMessageMaxRecord &&
          <CourseEditUserSearchList
            searchUserResult={searchUserResult}
            checkedUser={checkedUser}
            editingUser={editingUser}
            authority={authority}
            handlePageChange={this.handlePageChange}
            handleUserCheck={this.handleUserCheck}
            handleAddUserRelation={this.handleAddUserRelation}
            handleRemoveAllUserRelation={this.handleRemoveAllUserRelation}
            handlePeriodTimeChange={this.handlePeriodTimeChange}
            handleRemoveUserRelation={this.handleRemoveUserRelation}
            handleAddRemoveAllUser={this.handleAddRemoveAllUser}
            isShowMessageMaxRecord={isShowMessageMaxRecord}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
          />
          }
          <Col sm={12} className="msg-error bold padding-left-right-clear" style={{ paddingLeft: '13px' }}>
            {isShowMessageMaxRecord ? MessageTemplate.MSG_RESULT_OVER_MAX_RETURN_NUM : ''}
          </Col>
          <CourseEditUser
            editingUser={editingUser}
            authority={authority}
            recordNumUserCourseRelation={recordNumUserCourseRelation}
            handleRemoveAllUserRelation={this.handleRemoveAllUserRelation}
            handlePeriodTimeChange={this.handlePeriodTimeChange}
            handleRemoveUserRelation={this.handleRemoveUserRelation}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            isAdminHasCourseRelation={isAdminHasCourseRelation}
            isShowMessageMaxRecord={isShowMessageMaxRecord}
          />
          <Form.Group className={isShowMessageMaxRecord ? 'form-info' : 'form-info margin-top-50'}>
            <Col sm={12} className="text-center padding-top-10">
              <Button
                style={{ marginRight: '5px' }}
                onClick={this.handleBackBtn}
                className="btn-96"
                variant="default"
              >
                {'戻る'}
              </Button>
              <Button variant="primary" className="btn-96" onClick={this.handleNextBtn}>
                {'次へ'}
              </Button>
            </Col>
          </Form.Group>
          <SelectGroupDlg
            showModal={this.state.showSelectGroup}
            selectedGroup={searchUserCondition.selectedGroup}
            groupList={groupList}
            onCancel={this.cancelSelectGroupDlg}
            onOK={this.okSelectGroupDlg}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authority, user, course, group, authed, container } = state;
  const { groupList } = user;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  const { isAdminHasCourseRelation } = container;
  return {
    course,
    groupList,
    authority: authority.authorityInfo,
    userInfo,
    isAdminHasCourseRelation,
  };
};
export default connect(mapStateToProps)(CourseEditUserContainer);
